import React from "react";
import * as moment from "moment";
import { Table } from "reactstrap";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import TooltipMaterial from "@material-ui/core/Tooltip";
import DownloadInvoiceIcon from "assets/svg/DownloadInvoiceIcon";
import { invoiceDownload } from "redux/actions/invoice";
import { InvoiceTableContainer } from "./InvoiceTableStyle";
import { formatCurrencyByCountry, getLoggedInUserCountry } from "helpers";

const InvoiceTable = (props) => {
  const dispatch = useDispatch();
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const userCountry = getLoggedInUserCountry();
  const token = loggedInUserInfo?.token

  const downLoadInvoice = async (invoiceId, locationId) => {
    let response = await dispatch(invoiceDownload(token, invoiceId, locationId));
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Download Receipt.pdf");
    document.body.appendChild(link);
    link.click();
  };

  return (
    <InvoiceTableContainer>
      <Table responsive style={{ width: "100%" }}>
        <thead>
          <tr>
            {props?.headerArr.map((items, index) => (
              <th key={index}>{items}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props?.orderResponse?.invoiceList?.map((items, index) => (
            <>
              <tr
                className={index % 2 === 0 ? "odd-rows set-border" : "even-rows set-border"}
                key={index}
              >
                <td>
                  {items.locationName} - {items.location?.city}, {items.location?.state}{" "}
                </td>
                <td>
                  {items.invoiceNumber}{" "}
                </td>
                <td>
                  {moment(items.invoiceDate * 1000).format("MM/DD/YY")}{" "}
                </td>
                <td>
                  {formatCurrencyByCountry(items.totalAmount, userCountry)}{" "}
                </td>
                <td>
                  {items.orderType}{" "}
                </td>
                <td style={{ paddingLeft: '60px' }}>
                  <div onClick={() => downLoadInvoice(items.invoiceNumber, items.locationId)}>
                    <DownloadInvoiceIcon />
                  </div>
                </td>
              </tr>
            </>
          ))}{" "}
        </tbody>
      </Table>
    </InvoiceTableContainer>
  );
};

export default InvoiceTable;
